import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Coordinate } from '../../shared/model/coordinate';
import { FindHttpError } from '../../shared/error/find-http-error';
import { HttpRequestBuilder } from '../../core/http-request-builder';
import * as FileSaver from 'file-saver';
import { SendCommandRequest } from '../../shared/model/send-command-request';
import { CommandRequest } from '../../shared/model/command-request';
import { CommandType } from '../../shared/model/command-type';
import { DiagnosisWebSocketService } from './diagnosis-web-socket.service';
import { AccessoryRange } from '../../shared/model/accessory-range';

@Injectable()
export class DiagnosisService {
  public static DIAGNOSIS_END_POINT = '/diagnosis';

  private DOWNLOAD_COORDINATES = `${DiagnosisService.DIAGNOSIS_END_POINT}/report`;
  private REQUEST_COMMAND = `${DiagnosisService.DIAGNOSIS_END_POINT}/requestCommand`;
  private REQUEST_ADMEASUREMENT = `${DiagnosisService.DIAGNOSIS_END_POINT}/requestAdmeasurement`;
  private GET_LAST_HOUR_COORDINATES = `${DiagnosisService.DIAGNOSIS_END_POINT}/getCoordinatesFromVehicleBetweenDates`;
  private GET_COORDINATES_BY_DIAGNOSIS_ID = `${DiagnosisService.DIAGNOSIS_END_POINT}/getCoordinatesFromDiagnosis`;
  private GET_DIAGNOSIS_TYPE = `${DiagnosisService.DIAGNOSIS_END_POINT}/diagnosis-type`;

  constructor(private _http: HttpRequestBuilder, private _diagnosisNotification: DiagnosisWebSocketService) { }

  dowloadCoordinates(coordinates: Array<Coordinate>) {
    this._http.post(this.DOWNLOAD_COORDINATES, coordinates)
      .subscribe(csv => {
        FileSaver.saveAs(new Blob([csv._body], {type: 'text/csv'}),
                        'relatorio_coordenadas' + new Date().toDateString() + '.csv');
      });
  }

  disablePanic(vehicles?: Array<number>, parameters?, trixUserId?: number) {
    return this.sendCommand(vehicles, parameters, trixUserId, CommandType.DISABLE_PANIC);
  }

  blockVehicle(vehicles?: Array<number>, parameters?, trixUserId?: number) {
    return this.sendCommand(vehicles, parameters, trixUserId, CommandType.BLOCK_VEHICLE);
  }

  sendCommand(vehicles?: Array<number>, parameters?, trixUserId?: number, type?) {
    const trixUser = trixUserId || this._diagnosisNotification.getVehicle().trixUserId;
    const sendCommandRequest = this.createSendCommandRequest(vehicles, parameters, type);
    return this._http.post(`${this.REQUEST_COMMAND}?trixUserId=${trixUser}`, sendCommandRequest);
  }

  getLastHourCoordinates(vehicle?) {
    const interval = this.createCoordinatesInterval();
    return this._http
      .get(
        `${this.GET_LAST_HOUR_COORDINATES}/${vehicle.id}?trixUserId=${vehicle.trixUserId}&start=${interval.start}&end=${interval.end}`
      );
  }

  getCoordinatesFromDiagnosis(id) {
    return this._http
      .get(
        `${this.GET_COORDINATES_BY_DIAGNOSIS_ID}/${id}`
      );
  }

  createAdmeasurement(accessoryRange: AccessoryRange) {
    const vehicle = this._diagnosisNotification.getVehicle();
    const trixUser = vehicle.trixUserId;
    accessoryRange.vehicle = vehicle;
    accessoryRange.vehicleType = vehicle.vehicleType;
    return this._http.post(`${this.REQUEST_ADMEASUREMENT}?trixUserId=${trixUser}`, accessoryRange);
  }

  getDiagnosisticsTypes() {
    return this._http.get(this.GET_DIAGNOSIS_TYPE);
  }

  private createCoordinatesInterval() {
    const now = new Date().toISOString();
    const hourAgo = this.generateHourAgo();
    return {
      end: now,
      start: hourAgo
    };
  }

  private generateHourAgo() {
    const hourAgo = new Date();
    hourAgo.setHours(hourAgo.getHours() - 1);
    return hourAgo.toISOString();
  }

  private createCommandRequest(parameters?, type?) {
    const commandRequest = new CommandRequest();
    commandRequest.expirationDate = this.getTomorrow();
    commandRequest.maximumAttempts = 3;
    commandRequest.type = type;
    commandRequest.parameters = parameters;
    return commandRequest;
  }

  private createSendCommandRequest(vehicles?: Array<number>, parameters?, type?) {
    const sendCommandRequest = new SendCommandRequest();
    sendCommandRequest.commandRequest = this.createCommandRequest(parameters, type);
    sendCommandRequest.vehicles = vehicles || [this._diagnosisNotification.getVehicle().id];
    return sendCommandRequest;
  }

  private getTomorrow() {
    const tomorrow = new Date();
    tomorrow.setDate(new Date().getDate() + 1);
    return tomorrow.toISOString();
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/diagnosis/service/diagnosis.service.ts